// import { IconSprite } from "../IconSprite/IconSprite";
import { AttributeIcon } from "../../../assets/img/svg/AttributeIcon";
import { tooltipStyles } from "./styles";

import { BoxIcon, Span, TooltipStiled } from "./Attribute.styled";

export const Attribute = ({ children, tooltipText = "" }) => (
  <Span>
    {children}
    {/*<IconSprite tag={"attribute"} width={"16px"} height={"16px"} />*/}
    <TooltipStiled
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": tooltipStyles.tooltip,
          "& .MuiTooltip-arrow": tooltipStyles.arrow,
        },
      }}
      title={tooltipText}
      arrow
      placement="top"
    >
      <BoxIcon>
        <AttributeIcon />
      </BoxIcon>
    </TooltipStiled>
  </Span>
);
